import { render, staticRenderFns } from "./tier-downgrade.vue?vue&type=template&id=115b2464&"
import script from "./tier-downgrade.vue?vue&type=script&lang=js&"
export * from "./tier-downgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports